export class MicroappChargeTariffFilter{
    general: string;
}